import styled from 'styled-components';
import { colors, shadow } from './theme';

export const Main = styled.main`
  background-color: #fff;
  box-shadow: ${shadow.shadow};
  border-radius: 8px;
  width: 100%;
  overflow: hidden;

  a {
    display: block;
    padding: 11px 22px;
    font-size: 16px;
    line-height: 26px;
    position: relative;

    span {
      position: relative;
      z-index: 1;
    }

    &::after {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 0;
      height: 100%;
      content: '';
      background-color: ${colors.lightBlue};
      transition: 0.5s ease;
      opacity: 0;
      pointer-events: none;
    }

    &[aria-current='page'],
    &:hover {
      color: ${colors.blue};

      &:after {
        width: 100%;
        opacity: 1;
      }
    }
  }
`;
